import React from 'react';
import { Box, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { CaptionText, CardTitle, CompactPageTitle } from '../typography';
import { layoutGap } from '../../../theme/theme';

export interface MainLayoutTitleProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  headerMeta?: React.ReactNode;
  compact?: boolean;
}

const MainLayoutTitle: React.FC<MainLayoutTitleProps> = ({
  title,
  subtitle,
  headerMeta,
  compact = false,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 1,
        minHeight: compact ? 26 : 32,
        mb: compact ? 0.2 : 0.35,
        pr: 0,
        pb: compact ? 0.2 : 0,
        borderBottom: compact
          ? `1px solid ${alpha(theme.palette.divider, 0.08)}`
          : 'none',
      }}
    >
      <Box sx={{ minWidth: 0, display: 'grid', gap: layoutGap.micro }}>
        {compact ? (
          <CardTitle
            data-testid="page-title"
            sx={{
              color: theme.palette.text.primary,
              lineHeight: 1.2,
              letterSpacing: '0.02em',
            }}
          >
            {title}
          </CardTitle>
        ) : (
          <CompactPageTitle
            data-testid="page-title"
            sx={{
              color: theme.palette.text.primary,
              lineHeight: 1.2,
            }}
          >
            {title}
          </CompactPageTitle>
        )}
        {subtitle && (
          <CaptionText
            sx={{
              color: theme.palette.text.secondary,
              lineHeight: 1.25,
              maxWidth: { xs: '100%', md: 560 },
              display: compact ? { xs: 'none', sm: 'block' } : 'block',
            }}
          >
            {subtitle}
          </CaptionText>
        )}
      </Box>
      {headerMeta && (
        <Box sx={{ minWidth: 0, display: 'flex', alignItems: 'center', flexShrink: 0 }}>
          {headerMeta}
        </Box>
      )}
    </Box>
  );
};

export default MainLayoutTitle;
